import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const dropedCompleteMissionUsersAction = createAsyncThunk(
    'droped-completed-mission-users',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.get(`/admins/api/droped-completed-mission-users`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const dropedCompleteMissionUsersSlice = createSlice({
    name: 'droped-completed-mission-users',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(dropedCompleteMissionUsersAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(dropedCompleteMissionUsersAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(dropedCompleteMissionUsersAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const dropedCompleteMissionUsersReducer = dropedCompleteMissionUsersSlice.reducer    